module.exports = __webpack_public_path__ + "static/media/2.456abe90.gif";